import PositivoPlusCPFQuery from "../queries/PositivoPlusCPFQuery";
import ScrBacenScoreQuery from "../queries/ScrBacenScoreQuery";

export const componentsMap = {
  PositivoPlusCPFQuery,
  ScrBacenScoreQuery,
};
